import { create } from 'zustand';

// Estado del aviso "tu sesión está por expirar". Lo enciende el sessionTimer
// cuando faltan pocos minutos para que caduque el JWT y lo apaga al renovar,
// al cerrar sesión o al expirar. Es un store aparte para no acoplarlo al de
// usuario y que el banner se re-renderice solo cuando cambia.
type SessionWarningState = {
	active: boolean;
	/** epoch (segundos) de expiración del JWT vigente, para el conteo en vivo. */
	expiresAt?: number;
	show: (expiresAt: number) => void;
	hide: () => void;
};

export const useSessionWarning = create<SessionWarningState>((set) => ({
	active: false,
	expiresAt: undefined,
	show: (expiresAt) => set({ active: true, expiresAt }),
	hide: () => set({ active: false, expiresAt: undefined }),
}));
